export default {
    page_title: "Kevi | Relatório Geral",
    title: "Relatório Geral",
    stats: {
        clients: "Clientes",
        orders: "Pedidos",
        total_income: "Receita total",
        avg_ticket: "Ticket médio",
        avg_time_between_orders: "Tempo médio entre pedidos",
        incentivized_income: "Receita incentivada",
        base_clients: "Clientes da Base ({0}%)",
        days_suffix: "dias",
    },
    pie_chart: {
        first_time: "Primeira Vez",
        returned: "Voltaram",
    },
    downloads: {
        orders_aria_label: "Baixar arquivo com dados dos pedidos",
        orders_tooltip: "Baixar pedidos",
        incentivized_orders_aria_label:
            "Baixar arquivo com dados dos pedidos incentivados",
        incentivized_orders_tooltip: "Baixar incentivados",
    },
    filters: {
        first_order_period: "Período do primeiro pedido",
        client_segments: "Segmento do cliente",
        order_status: "Status do Pedido",
    },
    states: {
        empty: "Não há dados suficientes para o período",
    },
    charts: {
        orders_and_income_by: "Pedidos e Faturamento por",
        average_by: "Média por",
        retention_curve: "Curva de Retenção",
        income_by_field: "Faturamento por {0}",
        group_by: "Agrupar Por:",
    },
    chart_axes: {
        orders: "Pedidos",
        income: "Faturamento",
        client_percentage: "% de Clientes",
        orders_in_period: "Pedidos no período",
    },
    tooltips: {
        clients_percentage: "{0}% ({1} clientes)",
        not_informed: "Não informado",
    },
};
